export const selectPosts = state => state.social.posts
